import { h } from "preact";
import VideoPoster from "../../assets/images/video-poster.jpg";

const VideoBlock = ({ content }) => {
	return (
		<section id="protection" class="video protection">
			<section class="margin-auto">
				<h2 class="-title display3c">
					{content.video_title[0].text}
				</h2>
				<p class="-summary body">
					{content.video_copy[0].text}
				</p>
				<p class="-summary -link">
					<a href="/register?plan=pro" class="button -blue">
						{content.video_link_label[0].text}
					</a>
				</p>
			</section>
			<section class="video video__player" aria-hidden="true">
				<img
					src={VideoPoster}
					alt=""
					role="presentation"
					style="display: block; width: 100%; height: auto;"
				/>
			</section>
		</section>
	);
};

export default VideoBlock;
